import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetTodaysDate, GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import Button from "../../Button/Button";
import { InputsInTable } from "../../InputInTable/InputsInTable";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { NewRefModal } from "./NewRefModal";
import { AmountDetails, TransactionTypeDetails, initialRef, initialRefForNewRef } from "./Reference.config";
import { WarningModal } from "./WarningModal";
import { Addition, Subtraction } from "../../../../CommonFunction/CalculationsWithDecimalValues";
import { useModalContext } from "../../Reactportal/ModalContext";
import { WarningToast } from "../../ToastComponent/RectHotToast";
interface ObjType {
  id: number;
  name: string;
  Input: boolean;
  type: string;
  dropdowndata?: string[];
  value: number | string;
  NewRef_Id?: string;
}
interface TransactionRefType {
  [key: number]: ObjType[];
}

interface VoucherRef {
  [key: number]: TransactionRefType;
}

export type RowTypes = {
  id: number;
  Type: string;
  Particular: string;
  RefDate: string;
  Amount: number;
  TransactionType: string;
  Input: boolean;
  newRefAmount?: number;
  value?: number | string;
};

interface TableDataState {
  tableData: VoucherRef;
}
interface RootState {
  TableDataReducer: TableDataState;
}

export const ReferenceModal = ({
  show,
  setModalToggle,
  transactionId,
  Amount,
  Account_ID,
  query,
  Transaction_Type,
}: {
  show: boolean;
  setModalToggle: () => void;
  transactionId: number;
  Amount: number;
  Account_ID: string;
  query: any;
  Transaction_Type: string;
}) => {
  const Reference = {
    [Math.random() * 10]: [

      {
        id: Math.random() * 10,
        name: "Type",
        Input: true,
        type: "inputdrop",
        dropdowndata: Account_ID ? ["New Reference", "Against Ref", "On Account"] : ["New Reference", "On Account"],
        value: "",
        notSearchable: true
      },
      {
        id: Math.random() * 10,
        name: "Particular",
        Input: true,
        type: "text",
        value: "",
      },
      {
        id: Math.random() * 10,
        name: "RefDate",
        Input: true,
        type: "Date",
        value: GetTodaysDateINdmy(),
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        Input: true,
        type: "number",
        value: Amount,
      },
      {
        id: Math.random() * 10,
        name: "TransactionType",
        Input: true,
        type: "inputdrop",
        dropdowndata: ["Credit", "Debit"],
        value: Transaction_Type,
      },
      {
        id: Math.random() * 10,
        name: "Unique_Id",
        Input: true,
        type: "text",
        value: "",
        disabled: true,
      },

    ],
  };
  const Model_Key = "Vocher_Refrence";
  const { pushModal, popModal, } = useModalContext();
  const tableData: VoucherRef = useSelector((store: RootState) => store.TableDataReducer.tableData);
  console.log(tableData, transactionId)
  const [showWarning, setShowWarning] = useState(false);
  const [PendingValue, setPendingValue] = useState<number>(0);
  const [againstRefId, setAgainstRef] = useState(0);
  const [newRefmodal, OpenNewRefModal] = useState(false);
  const [prevNewRefId, setPrevNewRef] = useState<any[]>([])
  const NewReferenceData = useSelector((store: any) => store.UniqueTableReducer);
  console.log(Amount)
  const [RefRows, setRefRows] = useState<VoucherRef | any>({
    ...tableData,
    [transactionId]: tableData[transactionId] !== undefined && Object.keys(tableData[transactionId]).length !== 0 ? tableData[transactionId] : Reference,
  });
  console.log("tableData=", tableData, "\n", "tableData[transactionId]=", tableData[transactionId], "\nReference=", Reference, "\nother=", {
    ...tableData,
    [transactionId]: tableData[transactionId] !== undefined && Object.keys(tableData[transactionId]).length !== 0 ? tableData[transactionId] : Reference,
  }, "RefRowsRefRows0")
  const [toggle, settoggle] = useState<boolean>(show ? show : false);
  const dispatch = useDispatch();
  const Closeformfunction = () => {
    settoggle(false);
    setModalToggle();

    // dispatch({ type: "ClearData", payload: { data: {} } });
  };
  const CloseAndClearformfunction = () => {
    dispatch({ type: "CleartableData", payload: {} });
    Closeformfunction()
  }
  useEffect(() => {
    pushModal(Model_Key);
    return () => {
      popModal(Model_Key)
    }
  }, []);
  useEffect(() => {
    dispatch({
      type: "PendingValue",
      payload: { [transactionId]: PendingValue },
    });
  }, [PendingValue]);
  const handleDelete = (ID) => {
    Object.keys(RefRows[transactionId]).filter((keys) => {
      if (keys === ID) {
        delete RefRows[transactionId][keys];
      }
      return keys !== ID;
    });
    console.log(RefRows, "RefRowsRefRows1")
    setRefRows({
      ...RefRows,
    });
  };

  const handleRowClick = () => {
    console.log({
      ...RefRows,
      [transactionId]: {
        ...RefRows[transactionId],
        [Math.random() * 10]: [
          ...initialRef.slice(0, -1),
          { ...AmountDetails, value: Math.abs(PendingValue) },
          {
            ...TransactionTypeDetails,
            value: PendingValue > 0 ? "Debit" : "Credit",
          },
          initialRef[initialRef.length - 1],
        ]
      },
    }, "RefRowsRefRows2")
    setRefRows({
      ...RefRows,
      [transactionId]: {
        ...RefRows[transactionId],
        [Math.random() * 10]: [
          ...initialRef.slice(0, -1),
          { ...AmountDetails, value: Math.abs(PendingValue) },
          {
            ...TransactionTypeDetails,
            value: PendingValue > 0 ? "Debit" : "Credit",
          },
          initialRef[initialRef.length - 1],
        ]
      },
    });
  };
  const calculatePendingValue = () => {
    let calculateValue = Transaction_Type === "Credit" ? -1 * Amount : Amount;

    Object.keys(RefRows[transactionId])?.map((key) => {
      let tType = "";
      let tAmount = 0;
      RefRows[transactionId][key]?.map((el) => {
        console.log(el)
        if (el.name === "TransactionType") {
          tType = el.value;
        }
        if (el.name === "Amount") {
          tAmount = el.value;
        }
      });
      if (tType && tAmount) {
        calculateValue = tType === "Credit" ? Addition(calculateValue, tAmount) : Subtraction(calculateValue, tAmount);
      }
    });
    setPendingValue(calculateValue);
    return calculateValue;
  };
  useEffect(() => {
    calculatePendingValue();
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);

  const HandleInputChange = async (evt: React.ChangeEvent<HTMLInputElement>, Id: number, key: string) => {
    console.log(evt, Id, key, "p")
    if (typeof evt.target.value !== "number" || (typeof evt.target.value === "number" && evt.target.value !== 0)) {
      let tempTransactionAmount = PendingValue;
      // let Calculate_From_Next = false;
      let UpdatedObject = {};
      Object.keys(RefRows[transactionId]).map((keys) => {
        // if (keys === key) {
        //   Calculate_From_Next = true;
        // }
        if (keys === key) {
          let innerArray = RefRows[transactionId][keys]?.map((el) => {
            if (el.id === Id) {
              if (evt.target.name === "Particular") {

                return { ...el, value: String(evt.target.value) };

              } else if (evt.target.name === "Amount" && el.newRefAmount && tempTransactionAmount) {
                if (el.newRefAmount < Number(evt.target.value)) {
                  tempTransactionAmount = Subtraction(tempTransactionAmount, el.newRefAmount);

                  return { ...el, value: evt.target.value };
                } else {
                  let InputValue;

                  if (Number(evt.target.value) > tempTransactionAmount) {
                    InputValue = evt.target.value; //tempTransactionAmount;
                    tempTransactionAmount = 0;
                  } else {
                    InputValue = Number(evt.target.value);
                    tempTransactionAmount = Subtraction(tempTransactionAmount, InputValue);
                  }

                  return { ...el, value: InputValue };
                }
              } else {
                return { ...el, value: evt.target.value };
              }
            } else if (el.name === "Amount") {
              let InputValue;
              if (el.value) {
                InputValue = el.value;
                tempTransactionAmount = Subtraction(tempTransactionAmount, el.value);
              } else if (el.newRefAmount < tempTransactionAmount) {
                InputValue = Subtraction(tempTransactionAmount, el.newRefAmount);
                tempTransactionAmount = Subtraction(tempTransactionAmount, el.newRefAmount);
              } else {
                InputValue = tempTransactionAmount;
                tempTransactionAmount = 0;
              }
              setPendingValue(0);
              return { ...el };
              // }
            }
            else if (el.name === "Particular") {
              if (evt.target.name === "Type") {

                return {
                  ...el,
                  NewRef_Id
                    : "", value: ""
                };
              }
              return { ...el };
            }
            else {
              return { ...el };
            }
          });
          UpdatedObject = { ...UpdatedObject, [keys]: innerArray };
        } else {
          let innerArray = RefRows[transactionId][keys]?.map((el) => {
            if (el.name === "Amount") {
              tempTransactionAmount = Subtraction(tempTransactionAmount, el.value);

              return { ...el, value: el.value };
            }

            return { ...el };
          });
          UpdatedObject = { ...UpdatedObject, [keys]: innerArray };
        }
      });
      console.log({
        ...RefRows,
        [transactionId]: { ...RefRows[transactionId], ...UpdatedObject },
      }, "RefRowsRefRows3")
      setRefRows({
        ...RefRows,
        [transactionId]: { ...RefRows[transactionId], ...UpdatedObject },
      });
    }
  };


  console.log(RefRows)
  const handleOnFocus = (evt, Id, RefId) => {
    let flag = false
    RefRows[transactionId][Id]?.map((el: RowTypes) => {
      if (el.id === RefId) {
        if (evt.target.name === "Particular") {
          RefRows[transactionId][Id].map((item) => {
            console.log(item)
            if (item.name == "Particular") {
              console.log(item.NewRef_Id)
              setPrevNewRef([{ _id: item.NewRef_Id }])
            }
            if (item.name === "Type" && item.value === "Against Ref") {

              flag = true
              setAgainstRef(Id);
            }
          });
        }
      }
    });
    if (flag) {
      OpenNewRefModal(true);
    }
  };
  console.log(RefRows)
  const handleAginstRef = () => {
    let TempTransactionAmount = Amount;
    console.log([...RefRows[transactionId][againstRefId]], "RefRows", transactionId, againstRefId);
    let arr = [...RefRows[transactionId][againstRefId]]
    delete RefRows[transactionId][againstRefId];
    console.log(RefRows, "RefRowsRefRows4", againstRefId);
    setRefRows(RefRows);

    let addAgainstRef = {};
    console.log(NewReferenceData);

    NewReferenceData?.New_Ref_Modal?.Selected_Rows?.map((el, i) => {

      const existingRef = arr;
      const existingUniqueId = existingRef?.find(r => r.name === "Unique_Id")?.value;
      console.log(existingUniqueId)

      let updatedInitialRef = initialRefForNewRef.map((ref) => {
        if (i === 0) {

          if (ref.name === "Unique_Id" && existingUniqueId) {
            return { ...ref, value: existingUniqueId };
          }
        }

        if (ref.name === "Particular") {
          return { ...ref, value: el.Particular, NewRef_Id: el._id };
        }

        if (ref.name === "Type") {
          return { ...ref, value: "Against Ref" };
        }

        if (ref.name === "Amount") {
          if (Transaction_Type !== el.Closing_Amount_Type) {
            TempTransactionAmount = Addition(TempTransactionAmount, el.Amount);
            return { ...ref, value: el.Amount, newRefAmount: el?.Amount };
          } else {
            if (TempTransactionAmount >= el.Amount) {
              TempTransactionAmount = Subtraction(TempTransactionAmount, el.Amount);
              return {
                ...ref,
                value: el.Amount,
                newRefAmount: el?.Amount,
              };
            } else {
              let obj = {
                ...ref,
                value: TempTransactionAmount,
                newRefAmount: el?.Amount,
              };
              TempTransactionAmount = 0;
              return obj;
            }
          }
        }

        if (ref.name === "TransactionType") {
          return {
            ...ref,
            value: el?.Closing_Amount_Type === "Debit" ? "Credit" : "Debit",
          };
        }

        return { ...ref };
      });
      if (!(el._id in RefRows[transactionId])) {
        // delete RefRows[transactionId][againstRefId];
        addAgainstRef = {
          ...addAgainstRef,
          [el._id]: updatedInitialRef,
        };
      }
      return {
        [el._id]: updatedInitialRef,
      };
    });

    console.log({
      ...RefRows,
      [transactionId]: {
        ...RefRows[transactionId],
        ...addAgainstRef,
      },
    }, "RefRowsRefRows5");

    setRefRows({
      ...RefRows,
      [transactionId]: {
        ...RefRows[transactionId],
        ...addAgainstRef,
      },
    });

    setPendingValue(calculatePendingValue());
    calculatePendingValue();
  };

  let headers = ["Type", "Particular", "RefDate", "Amount", "TransactionType", "Unique Id", ""];

  const handleSubmit = () => {
    if (PendingValue !== 0) {
      WarningToast("Set Total Value To Given Adjestment Balance")
    } else {
      let check = areAllTypeFieldsFilled(RefRows)
      if (check) {
        let inpId = document.getElementById(check)
        console.log(inpId)

        inpId.focus()
      }
      else {
        dispatch({ type: "tableData", payload: RefRows });
        Closeformfunction();

      }
    }
  };
  let Pending = Transaction_Type === "Credit" ? Subtraction(-1 * Amount, PendingValue) : Subtraction(Amount, PendingValue);


  const areAllTypeFieldsFilled = (data) => {

    const innerObj = data[transactionId];
    for (const innerKey in innerObj) {
      const items = innerObj[innerKey];
      for (const item of items) {
        if (item.name === "Type" && (!item.value || item.value.trim() === "")) {
          console.log(innerKey)
          WarningToast(`Select Reference Type for all the References`)
          return `${innerKey}-${item?.name}`;
        }
        if (item.name === "Particular" && (!item.value || item.value.trim() === "")) {
          console.log(innerKey)
          WarningToast(`Provide Particular for all the References`)
          return `${innerKey}-${item?.name}`;
        }
      }
    }

    return false;
  };


  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"Reference"}
        TypeOfId={"Account Id :"}
        UserRightsPortal={false}
      >
        <div className="RefContainer">
          <p>
            <span>Transaction Amount :</span>
            {Amount}
            {Transaction_Type === "Credit" ? " Cr" : " Dr"}
          </p>
          <div className="RefTable">

            <InputsInTable
              title={"ReferenceData"}
              headers={headers}
              data={RefRows[transactionId]}
              HandleInputChange={HandleInputChange}
              handleOnFocus={handleOnFocus}
              handleDelete={handleDelete}
            />
          </div>

          <div className="buttonAndCalc">
            <Button
              action={handleRowClick}
              text="Add Another Line"
              name="AddRow"
              type=""
              children=""
              disabled={false}
            />
            <div className="PendingTotal">
              <p>
                Reference Total:
                {Pending > 0 ? Pending.toFixed(2) + " Dr" : (Pending * -1).toFixed(2) + " Cr"}
              </p>
              <p>
                Pending Adjustment:
                {PendingValue > 0 ? PendingValue + " Dr" : -1 * PendingValue + " Cr"}
              </p>
            </div>
          </div>
          <div className="NewRefContainerParent">
            {newRefmodal && (
              <NewRefModal
                Account_ID={Account_ID}
                modalOpen={newRefmodal}
                OpenModal={() => OpenNewRefModal(false)}
                handleAginstRef={handleAginstRef}
                query={query}
                newRefId={prevNewRefId}
              />
            )}
          </div>
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={handleSubmit}
          Form_key={Model_Key}
          submitType={"Save & Close"}
          handleformclose={Closeformfunction}
          loadingState={false}
          Cancletype={"Close"}
          TypeOfPortal={"Reference "}
          disableupload={false}
        />
      </Reactportal>
      {showWarning && <WarningModal show={showWarning} setShowWarning={setShowWarning} />}
    </>
  );
};
